"use strict";

exports.__esModule = true;
exports.default = void 0;
var _arrayFilter = _interopRequireDefault(require("./_arrayFilter.js"));
var _stubArray = _interopRequireDefault(require("./stubArray.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? _stubArray.default : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return (0, _arrayFilter.default)(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};
var _default = exports.default = getSymbols;